export function shouldCloseModal(data) {

  return Object.entries(data).every(([key, value]) => {
    if (Array.isArray(value)) {
      // Check if array is empty or all items inside are empty
      return (
        value.length === 0 || value.every((item) => shouldCloseModal(item))
      );
    } else if (typeof value === "object" && value !== null) {
      return shouldCloseModal(value);
    } else {
      return value === "" || value === 0 || value === null;
    }
  });
}
